module.exports = __webpack_public_path__ + "media/images/add-5dec4751e9677b343d70dc8ac94f62b6.gif";